import {
  CREATE_HOUSE_NUMBER_RULE_SUCCESS,
  DELETE_HOUSE_NUMBER_RULE_SUCCESS,
  FETCH_HOUSE_NUMBER_RULES_APPEND,
  FETCH_HOUSE_NUMBER_RULES_SUCCESS,
  FETCH_TDP_AREAS_APPEND,
  FETCH_TDP_AREAS_FAILURE,
  FETCH_TDP_AREAS_REQUEST,
  FETCH_TDP_AREAS_SUCCESS,
  HOUSE_NUMBER_RULES_FAILURE,
  HOUSE_NUMBER_RULES_REQUEST,
  SET_SELECTED_TDP,
  UPDATE_HOUSE_NUMBER_RULE_SUCCESS,
} from "../action/types";
import {
  genAddresses,
  needsReview,
} from "constants/housenumberhelper";

const initialState = {
  rules: {},
  rulesHasMore: {},
  tdpAreas: [], // danh sách khu vực dùng cho trang số nhà
  tdpAreasLoading: false,
  tdpAreasHasMore: true,
  selectedTdp: null,
  loading: false,
  error: null,
  fetched: false,
};

const houseNumberRuleReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case HOUSE_NUMBER_RULES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case HOUSE_NUMBER_RULES_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case FETCH_HOUSE_NUMBER_RULES_SUCCESS: {
      const { areaId, rules } = payload || {};
      const list = rules || [];
      return {
        ...state,
        loading: false,
        rules: {
          ...state.rules,
          ...(areaId ? { [areaId]: list } : {}),
        },
        rulesHasMore: {
          ...state.rulesHasMore,
          ...(areaId ? { [areaId]: list.length >= 15 } : {}),
        },
        fetched: true,
      };
    }

    case FETCH_HOUSE_NUMBER_RULES_APPEND: {
      const { areaId, rules } = payload || {};
      const newRules = rules || [];
      const currentList = (areaId && state.rules[areaId]) || [];
      return {
        ...state,
        loading: false,
        rules: {
          ...state.rules,
          ...(areaId ? { [areaId]: [...currentList, ...newRules] } : {}),
        },
        rulesHasMore: {
          ...state.rulesHasMore,
          ...(areaId ? { [areaId]: newRules.length >= 15 } : {}),
        },
      };
    }

    case CREATE_HOUSE_NUMBER_RULE_SUCCESS: {
      const areaId = payload.areaId;
      const list = state.rules[areaId] || [];
      return {
        ...state,
        loading: false,
        rules: {
          ...state.rules,
          [areaId]: [...list, payload],
        },
        tdpAreas: state.tdpAreas.map((area) => {
          const id = area.id || area._id;
          if (String(id) === String(areaId)) {
            return {
              ...area,
              numberOfRules: (area.numberOfRules || 0) + 1,
              numberOfHouses:
                (area.numberOfHouses || 0) + genAddresses(payload).length,
              numberOfMissingRules:
                (area.numberOfMissingRules || 0) +
                (needsReview(payload) ? 1 : 0),
            };
          }
          return area;
        }),
      };
    }

    case UPDATE_HOUSE_NUMBER_RULE_SUCCESS: {
      const areaId = payload.areaId;
      const list = state.rules[areaId] || [];
      const previousRule = list.find(
        (rule) => String(rule.id) === String(payload.id),
      );
      const houseCountDelta = previousRule
        ? genAddresses(payload).length - genAddresses(previousRule).length
        : 0;
      const missingRuleCountDelta = previousRule
        ? (needsReview(payload) ? 1 : 0) -
          (needsReview(previousRule) ? 1 : 0)
        : 0;
      return {
        ...state,
        loading: false,
        rules: {
          ...state.rules,
          [areaId]: list.map((r) =>
            String(r.id) === String(payload.id) ? payload : r,
          ),
        },
        tdpAreas: state.tdpAreas.map((area) => {
          const id = area.id || area._id;
          if (String(id) === String(areaId)) {
            return {
              ...area,
              numberOfHouses: Math.max(
                0,
                (area.numberOfHouses || 0) + houseCountDelta,
              ),
              numberOfMissingRules: Math.max(
                0,
                (area.numberOfMissingRules || 0) + missingRuleCountDelta,
              ),
            };
          }
          return area;
        }),
      };
    }

    case DELETE_HOUSE_NUMBER_RULE_SUCCESS: {
      const { tdpId: areaId, id } = payload;
      const list = state.rules[areaId] || [];
      const deletedRule = list.find(
        (rule) => String(rule.id) === String(id),
      );
      return {
        ...state,
        loading: false,
        rules: {
          ...state.rules,
          [areaId]: list.filter((r) => String(r.id) !== String(id)),
        },
        tdpAreas: state.tdpAreas.map((area) => {
          const aId = area.id || area._id;
          if (String(aId) === String(areaId)) {
            return {
              ...area,
              numberOfRules: Math.max(0, (area.numberOfRules || 0) - 1),
              numberOfHouses: Math.max(
                0,
                (area.numberOfHouses || 0) -
                  (deletedRule ? genAddresses(deletedRule).length : 0),
              ),
              numberOfMissingRules: Math.max(
                0,
                (area.numberOfMissingRules || 0) -
                  (deletedRule && needsReview(deletedRule) ? 1 : 0),
              ),
            };
          }
          return area;
        }),
      };
    }

    case SET_SELECTED_TDP:
      return {
        ...state,
        selectedTdp: payload,
      };

    case FETCH_TDP_AREAS_REQUEST:
      return { ...state, tdpAreasLoading: true };

    case FETCH_TDP_AREAS_SUCCESS: {
      const items = Array.isArray(payload) ? payload : [];
      return {
        ...state,
        tdpAreasLoading: false,
        tdpAreas: items,
        tdpAreasHasMore: items.length >= 15,
      };
    }

    case FETCH_TDP_AREAS_APPEND: {
      const newItems = Array.isArray(payload) ? payload : [];
      return {
        ...state,
        tdpAreasLoading: false,
        tdpAreas: [...state.tdpAreas, ...newItems],
        tdpAreasHasMore: newItems.length >= 15,
      };
    }

    case FETCH_TDP_AREAS_FAILURE:
      return { ...state, tdpAreasLoading: false };

    default:
      return state;
  }
};

export default houseNumberRuleReducer;
